// File upload progress component
class FileUploadProgress {
  constructor() {
    this.progressBar = null;
    this.progressContainer = null;
    this.checkInterval = null;
    this.isDestroyed = false;
    this.cleanup = this.cleanup.bind(this);
  }

  init() {
    this.createProgressBar();
    // Start checking immediately
    this.checkProgress();
    // Then set up interval
    this.checkInterval = setInterval(() => {
      if (!this.isDestroyed) {
        this.checkProgress();
      }
    }, 2000);
  }

  cleanup() {
    this.isDestroyed = true;
    
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }

    if (this.progressContainer && document.body.contains(this.progressContainer)) {
      document.body.removeChild(this.progressContainer);
      this.progressContainer = null;
      this.progressBar = null;
      this.statusText = null;
    }
  }

  createProgressBar() {
    // Create progress container
    this.progressContainer = document.createElement('div');
    this.progressContainer.className = 'progress-container';
    this.progressContainer.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      width: 400px;
      z-index: 1000;
    `;

    // Create progress bar
    const progressWrapper = document.createElement('div');
    progressWrapper.className = 'progress';
    progressWrapper.style.cssText = `
      height: 20px;
      background-color: #f0f0f0;
      border-radius: 10px;
      overflow: hidden;
      margin: 10px 0;
    `;

    this.progressBar = document.createElement('div');
    this.progressBar.className = 'progress-bar';
    this.progressBar.style.cssText = `
      width: 0%;
      height: 100%;
      background-color: #0d6efd;
      transition: width 0.3s ease;
    `;

    // Create status text
    this.statusText = document.createElement('div');
    this.statusText.className = 'text-center';
    this.statusText.textContent = 'Processing file...';

    // Assemble components
    progressWrapper.appendChild(this.progressBar);
    this.progressContainer.appendChild(this.statusText);
    this.progressContainer.appendChild(progressWrapper);
    document.body.appendChild(this.progressContainer);
  }

  async checkProgress() {
    if (this.isDestroyed) return;

    try {
      const response = await fetch('/api/v1/file_imports/status');
      const data = await response.json();
      
      // If destroyed during the fetch, don't update
      if (this.isDestroyed) return;
      
      // Update progress bar if it exists
      if (this.progressBar && document.body.contains(this.progressContainer)) {
        this.progressBar.style.width = `${data.percentage}%`;
      }
      
      if (data.status === 'failed') {
        if (this.statusText && document.body.contains(this.progressContainer)) {
          this.statusText.textContent = 'Upload failed. Please check the import files page for errors.';
          this.statusText.style.color = '#dc3545';
          setTimeout(() => {
            if (!this.isDestroyed) {
              window.location.reload();
            }
          }, 3000);
        }
        this.cleanup();
      } else if (data.status === 'completed' || data.status === 'completed_with_errors' || data.percentage === 100) {
        if (this.statusText && document.body.contains(this.progressContainer)) {
          if (data.status === 'completed_with_errors') {
            this.statusText.textContent = 'Upload completed with some errors. Check the details page.';
            this.statusText.style.color = '#ffc107';
          } else {
            this.statusText.textContent = 'Upload completed successfully!';
            this.statusText.style.color = '#198754';
          }
          setTimeout(() => {
            if (!this.isDestroyed) {
              window.location.href = '/file_imports';
            }
          }, 2000);
        }
        this.cleanup();
      }
    } catch (error) {
      console.error('Error checking progress:', error);
      if (!this.isDestroyed && !document.body.contains(this.progressContainer)) {
        this.cleanup();
      }
    }
  }
}

export default FileUploadProgress;
